/**
* Copyright (c) 2018
* @summary This file is use under Study -> Study Details -> Site Details
          Open Popup and show form for add perssonel
* @author Mangesh Pimprikar,Ankur Vishwakarma,Poonam Banode,Irfan Bagwan
*
*/
import React, { Component } from 'react';
import ReactTable from 'react-table';
import { cloneDeep } from 'lodash';
import { sortBy } from 'lodash/collection';
import { get } from 'lodash/object';

import { ProtocolApi } from '../../../../../api';
import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import {
  scBlue10,
  scBlue100,
  scGreen10,
  scGreen80,
  scPurple20,
  scPurple50
} from '../../../../../constants/systemColors';
import { pendoTrackDefaultSortingChange } from '../../../../../pendo/PendoUtils';
import { onRequestError } from '../../../../../services/handlers';

import 'react-table/react-table.css';

const COLUMNS = {
  EPOCHNAME: { name: 'Epoch Name', order: 2 },
  ENCOUNTERNAME: { name: 'Encounter Name', order: 3 },
  ENCOUNTERFROMVISIT: { name: 'From Visit', order: 4 },
  ENCOUNTERTOVISIT: { name: 'To Visit', order: 5 },
  ENCOUNTERFROMTYPE: { name: 'From Type', order: 6 },
  ENCOUNTERTOTYPE: { name: 'To Type', order: 7 },
  ELEMENTNAME: { name: 'ItemGroup Name', order: 8 },
  ITEMGROUPNAME: { name: 'ItemGroup Name', order: 9 },
  ACCESSTYPE: { name: 'Access', order: 10 }
};

class AuditTrailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comprision: [],
      versionList: [],
      currentVersion: '',
      oldVersion: '',
      currentVersionNo: '',
      oldVersionNo: '',

      levels: ['Epoch', 'Encounter', 'ItemGroup'],
      selectedLevel: 'Epoch',
      comprisionData: [],
      comprisionColumn: []
    };
  }

  componentDidMount() {
    if (this.props.selectedStudy) {
      ProtocolApi.getProtocols(this.props.selectedStudy).then(res => {
        if (res.data && typeof res.data.response === 'object') {
          this.setState({ versionList: res.data.response }, () => {
            if (this.state.versionList && this.state.versionList.length && this.state.versionList.length > 1) {
              this.setState(
                {
                  currentVersion: this.state.versionList[1].uniqueIdentifier,
                  oldVersion: this.state.versionList[0].uniqueIdentifier,
                  currentVersionNo: this.state.versionList[1].version,
                  oldVersionNo: this.state.versionList[0].version
                },
                () => {
                  this.doCompare();
                }
              );
            } else if (this.state.versionList && this.state.versionList.length && this.state.versionList.length > 0) {
              this.setState(
                {
                  currentVersion: this.state.versionList[0].uniqueIdentifier,
                  oldVersion: this.state.versionList[0].uniqueIdentifier
                },
                () => {
                  this.doCompare();
                }
              );
            }
          });
        }
      });
    }
  }

  doCompare() {
    if (
      this.state.currentVersion !== '' &&
      this.state.currentVersion !== 'Select' &&
      this.state.oldVersion !== '' &&
      this.state.oldVersion !== 'Select' &&
      this.state.selectedLevel !== ''
    ) {
      const level =
        this.state.selectedLevel.toLowerCase() === 'itemgroup' ? 'element' : this.state.selectedLevel.toLowerCase();
      ProtocolApi.getAuditTrailDetails(level, this.state.currentVersion, this.state.oldVersion).then(res => {
        const encounterDiff = res?.data?.response;
        if (encounterDiff) {
          const added = this.getFormattedEncountersByDiffCategory(encounterDiff, 'added');
          const removed = this.getFormattedEncountersByDiffCategory(encounterDiff, 'removed');
          const updated = this.getFormattedEncountersByDiffCategory(encounterDiff, 'updated');
          const match = this.getFormattedEncountersByDiffCategory(encounterDiff, 'match');
          const formattedDiff = added.concat(removed, updated, match);

          let columnsKeys = [];
          const reactTblCol = [];

          if (res.data.response.added && res.data.response.added.length) {
            columnsKeys = Object.keys(res.data.response.added[0]);
          } else if (res.data.response.removed && res.data.response.removed.length) {
            columnsKeys = Object.keys(res.data.response.removed[0]);
          } else if (res.data.response.updated && res.data.response.updated.length) {
            columnsKeys = Object.keys(res.data.response.updated[0]);
          } else if (res.data.response.match && res.data.response.match.length) {
            columnsKeys = Object.keys(res.data.response.match[0]);
          }

          columnsKeys.forEach((colK, colI) => {
            if (
              colK !== 'flag' &&
              colK !== 'encounterToType' &&
              colK !== 'encounterFromType' &&
              colK !== 'epochIdentifier' &&
              colK !== 'encounterIdentifier' &&
              colK !== 'elementIdentifier'
            ) {
              const objTemp = {
                Header: get(COLUMNS, colK.toUpperCase() + '.name', colK),
                accessor: colK
              };
              reactTblCol.push(objTemp);
            }
          });

          const orderedColumns = sortBy(reactTblCol, [
            column => get(COLUMNS, column.accessor.toUpperCase() + '.order')
          ]);
          this.setState({ comprisionData: formattedDiff, comprisionColumn: orderedColumns });
        }
      }, onRequestError);
    }
  }

  formatFromAndToVisit(encounter) {
    if (encounter.hasOwnProperty('encounterFromVisit') && encounter.hasOwnProperty('encounterFromType')) {
      encounter.encounterFromVisit = this.getFormattedVisitRange(
        encounter?.encounterFromVisit,
        encounter?.encounterFromType
      );
    }
    if (encounter.hasOwnProperty('encounterToVisit') && encounter.hasOwnProperty('encounterToType')) {
      encounter.encounterToVisit = this.getFormattedVisitRange(encounter?.encounterToVisit, encounter?.encounterToType);
    }
  }

  getFormattedEncountersByDiffCategory(encounterDiff, diffCategory) {
    const encounterDiffByCategory = cloneDeep(encounterDiff[diffCategory]);
    if (encounterDiffByCategory) {
      encounterDiffByCategory.forEach(encounter => {
        encounter.flag = diffCategory;
        this.formatFromAndToVisit(encounter);
      });
      return encounterDiffByCategory;
    }
    return [];
  }

  getFormattedVisitRange(duration, type) {
    if (!duration || !type) {
      return '-';
    } else {
      return `${duration}-${type}`;
    }
  }

  sourceVersionChangeHandler = (e, type) => {
    const index = e.nativeEvent.target.selectedIndex;
    if (type === 'current') {
      this.setState({ currentVersion: e.target.value, currentVersionNo: e.nativeEvent.target[index].text }, () => {
        this.doCompare();
      });
    } else {
      this.setState({ oldVersion: e.target.value, oldVersionNo: e.nativeEvent.target[index].text }, () => {
        this.doCompare();
      });
    }
  };

  levelChangeHandeler = e => {
    this.setState({ selectedLevel: e.target.value }, () => {
      this.doCompare();
    });
  };

  getRowColor = rowInfo => {
    if (rowInfo && rowInfo.original.flag && rowInfo.original.flag === 'added') {
      return scGreen10;
    }
    if (rowInfo && rowInfo.original.flag && rowInfo.original.flag === 'removed') {
      return scPurple20;
    }
    if (rowInfo && rowInfo.original.flag && rowInfo.original.flag === 'updated') {
      return scBlue10;
    }
    return '';
  };

  getCompareString() {
    if (this.state.currentVersionNo && this.state.oldVersionNo) {
      const no1 = parseInt(this.state.currentVersionNo.split('V')[1]);
      const no2 = parseInt(this.state.oldVersionNo.split('V')[1]);
      return no1 >= no2
        ? `Comparing ${this.state.oldVersionNo} with ${this.state.currentVersionNo}`
        : `Comparing ${this.state.currentVersionNo} with ${this.state.oldVersionNo}`;
    }
    return '';
  }

  render(
    { className } = this.props,
    { currentVersion, levels, selectedLevel, versionList, oldVersion, comprisionData, comprisionColumn } = this.state
  ) {
    return (
      <>
        <ModalBoxes.Body>
          <div className="header bg-light-grey   p-2 text-center d-flex ">
            <div className="float-left">
              <span className="pt-1">Level</span>
              <select value={selectedLevel} className="ml-2 p-1 " onChange={e => this.levelChangeHandeler(e)}>
                {levels &&
                  levels.map((vl, vi) => {
                    return (
                      <option key={vi} value={vl}>
                        {vl}
                      </option>
                    );
                  })}
              </select>
            </div>
            <div className="pull-right" style={{ marginLeft: '372px' }}>
              <span className="pt-1">Source</span>
              <select
                className="ml-2 p-1 "
                value={currentVersion}
                onChange={e => {
                  this.sourceVersionChangeHandler(e, 'current');
                }}
              >
                <option>Select</option>
                {versionList &&
                  versionList.map((vl, vi) => {
                    return (
                      <option value={vl.uniqueIdentifier} key={vi}>
                        {vl.version}
                      </option>
                    );
                  })}
              </select>
            </div>
            <div className="pull-right" style={{ marginLeft: '80px' }}>
              <span className="pt-1">Target</span>
              <select
                className="ml-2 p-1 "
                value={oldVersion}
                onChange={e => {
                  this.sourceVersionChangeHandler(e, 'old');
                }}
              >
                <option>Select</option>
                {versionList &&
                  versionList.map((vl, vi) => {
                    return (
                      <option key={vi} value={vl.uniqueIdentifier}>
                        {vl.version}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>

          <div className="col-12 py-2 p-0">
            <div className="row">
              <div className="col-8 c-p">{/* <h5>{this.getCompareString()} </h5> */}</div>
              <div className="col p-0">
                <div className="float-left mt-1" style={{ width: '14px', height: '14px', background: scGreen80 }} />
                <span className="ml-1" style={{ color: scGreen80 }}>
                  Added
                </span>
              </div>
              <div className="col p-0">
                <div className="float-left mt-1" style={{ width: '14px', height: '14px', background: scPurple50 }} />
                <span className="ml-1" style={{ color: scPurple50 }}>
                  Removed
                </span>
              </div>
              <div className="col p-0">
                <div className="float-left mt-1" style={{ width: '14px', height: '14px', background: scBlue100 }} />
                <span className="ml-1" style={{ color: scBlue100 }}>
                  Updated
                </span>
              </div>
            </div>
          </div>

          <div className="col-12 p-0" style={{ maxHeight: '500px', overflow: 'auto', minHeight: '32px' }}>
            <ReactTable
              data={comprisionData}
              columns={comprisionColumn}
              minRows={1}
              multiSort
              onSortedChange={pendoTrackDefaultSortingChange}
              showPagination
              nextText=">>"
              previousText="<<"
              noDataText="No Record Found"
              defaultPageSize={10}
              getTrProps={(state, rowInfo, column) => {
                return {
                  style: {
                    background: this.getRowColor(rowInfo)
                  }
                };
              }}
            />
          </div>
        </ModalBoxes.Body>
      </>
    );
  }
}

AuditTrailModal.className = 'audit-trail-popup-modal';
AuditTrailModal.size = 'w900';

export default AuditTrailModal;
